import { render } from "./SecondStepServicesForm.vue?vue&type=template&id=25e60284"
import script from "./SecondStepServicesForm.vue?vue&type=script&lang=js"
export * from "./SecondStepServicesForm.vue?vue&type=script&lang=js"

import "./SecondStepServicesForm.vue?vue&type=style&index=0&id=25e60284&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__